import { Log } from '@amzn/showtime';
import TENANT_ID from '../TenantId';
const logger = Log(TENANT_ID);
const stringToDataAttr = (str) => {
    const attr = str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
    return `data-${attr}`;
};
function validateDefined(object, appName) {
    const missingKeys = Object.keys(object)
        .filter((key) => object[key] === undefined)
        .map(stringToDataAttr);
    if (missingKeys.length) {
        const msg = 'required data-* attributes are missing from the root element';
        throw new Error(`${msg} '${appName}':\n${missingKeys.join('\n')}`);
    }
    // If an error wasn't thrown then all attributes are present, so convert to a full type
    return object;
}
// parse data-popstar-features and check for valid string array type
// throws an error if JSON parsing fails or the type is invalid
export const parsePopstarFeatures = (popstarFeatures, appName) => {
    let enabledFeatures;
    try {
        if (popstarFeatures !== undefined) {
            const parsed = JSON.parse(popstarFeatures);
            if (Array.isArray(parsed) && parsed.every((item) => typeof item === 'string')) {
                enabledFeatures = parsed;
            }
        }
    }
    catch (_a) {
        // handled below to include the type checking case
    }
    // throw an error if enabledFeatures wasn't set
    // caused by a JSON parsing error or invalid type check
    if (enabledFeatures === undefined) {
        throw new Error(`data-popstar-features must be defined on the root '${appName}' as a string list`);
    }
    return enabledFeatures;
};
// parse data-providable-urls
// throws an error if JSON parsing fails
export const parseProvidableUrls = (providableUrls) => {
    if (!providableUrls) {
        return undefined;
    }
    try {
        return JSON.parse(providableUrls);
    }
    catch (err) {
        logger.error('error parsing \'data-providable-urls\'');
        throw err;
    }
};
// parses and validates the required data-* attributes from the root element dataset
// throws an error if any of them are undefined
export const parseDataAttributes = (data = {}, appName) => {
    // parse context from data-* attributes
    const { authenticatedEmployeeId, employeeId, popstarFeatures, providableUrls, } = data;
    const userContext = {
        authenticatedEmployeeId,
        employeeId,
        isSpoofing: employeeId !== authenticatedEmployeeId,
        enabledFeatures: parsePopstarFeatures(popstarFeatures, appName),
    };
    const validatedUserContext = validateDefined(userContext, appName);
    const validatedProvidableUrls = parseProvidableUrls(providableUrls);
    return {
        providableUrls: validatedProvidableUrls,
        userContext: validatedUserContext,
    };
};
//# sourceMappingURL=DataAttributeParsing.js.map